import React from "react";
import ReactDOM from "react-dom/client";

// Sentry must be initialized BEFORE React renders so the SDK can install
// global error handlers and capture errors thrown during initial render.
import { initSentry } from "@/lib/sentry";
initSentry();

import "@/index.css";
import App from "@/App";
import AppErrorBoundary from "@/components/errors/AppErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>,
);